import { Record } from 'immutable';

import { InsightCostTermLabel } from 'enums/insight-type';

const InsightCostRecord = Record({
  minPercentage: null,
  maxPercentage: null,
  title: '',
  label: '',
  amount: null,
  currency: null,
  includeVat: false,
});

export default class InsightCost extends InsightCostRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    return new InsightCost({
      ...jsonObject,
      term: InsightCostTermLabel[jsonObject.term],
    });
  }

  get range() {
    if (this.minPercentage === null && this.maxPercentage === null) {
      return '';
    }

    if (this.minPercentage === 0 && this.maxPercentage === 0) {
      return '';
    }

    if (this.minPercentage !== null && this.minPercentage === this.maxPercentage) {
      return `${this.minPercentage || this.maxPercentage}%`;
    }

    return `${this.minPercentage} - ${this.maxPercentage}%`;
  }
}
